module.exports = __webpack_public_path__ + "img/숙대 미용실.485cdbbf.png";